import { render, staticRenderFns } from "./daidiLoading.vue?vue&type=template&id=b067d11a&scoped=true"
import script from "./daidiLoading.vue?vue&type=script&lang=js"
export * from "./daidiLoading.vue?vue&type=script&lang=js"
import style0 from "./daidiLoading.vue?vue&type=style&index=0&id=b067d11a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b067d11a",
  null
  
)

export default component.exports